import { EndOrderTable, firestoreDateParser } from '@pedix-workspace/utils';

export const parseOrderTableDates = (
  table: EndOrderTable | undefined,
): EndOrderTable | undefined => {
  if (!table) {
    return undefined;
  }

  return {
    ...table,
    openedAt: firestoreDateParser(table.openedAt),
    closedAt: firestoreDateParser(table.closedAt),
  };
};
